import { Box, Container, Modal, Typography } from "@mui/material";
import { Button, Divider } from "@axismaxlife/unified-ui-components-library";
import React, { useContext, useEffect, useState } from "react";
import { PageTitle } from "../../commanComponents/PageTitle";
import { JourneyProgressStepper } from "../../commanComponents/JourneyProgressStepper";
import { ImageLibrary } from "../../constants/ImageLibrary";
import { String } from "../../constants/Strings";
import { colors } from "../../style/color/colors";
import { useNavigate } from "react-router-dom";
import WebViewComponent from "./WebViewComponent";
import { DataContext } from "../../Hooks/context/ChildData";
import { useAccountAggregator } from "../../api/apiEndpoints/AccountAggragator";
import { AuthContext } from "../../Hooks/context/AuthContext";
import { AppToast } from "../../commanComponents/AppToast";
import { AccountAagregatorContext } from "../../Hooks/context/AccountAaggregator";
import { fonts } from "../../style/fonts/fonts";
import { gaCustomEvent } from "../../logic/CommonFunctions";
import { OTPVerifyContext } from "../../Hooks/context/OTPVeriryContext";

const InfoFetch = () => {
  const [iframesrc, setIframesrc] = useState(null);
  const [open, setOpen] = useState(false);
  const [requestId, setRequestId] = useState(null);
  const [pollingInterval, setPollingInterval] = useState(null);
  const [pollingCounter, setPollingCounter] = useState(0);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState({
    message: "",
    severity: "",
  });
  const navigation = useNavigate();
  const { EnterManually } = useContext(DataContext);
  const { startJouenry, startPolling, getResult } = useAccountAggregator();
  const { authTokens } = useContext(AuthContext);
  const { verifyData } = useContext(OTPVerifyContext);
  const { collectAccountAggregatorData } = useContext(AccountAagregatorContext);
  const { userId } = authTokens;

  const startPollingResult = async (data) => {
    if (data) {
      const response = await startPolling({ requestId: data });
      if (
        response.httpCode === 200 &&
        response.response.state.state === "SUCCESS"
      ) {
        clearInterval(pollingInterval);
        const result = await getResult({ requestId: data, userId: userId });
        collectAccountAggregatorData(result);
        navigation("/financialsnapshot", { state: { replace: true } });
      }
      setPollingCounter((prevCounter) => prevCounter + 1);
      if (pollingCounter >= 25) {
        setIframesrc(null);
        setOpen(false);
        setPollingCounter(0);
        setSnackbarMessage({
          message: String.AccountAggregator.faildOFetchDatainPolling,
          severity: String.ErrorSeverity,
        });
        setShowSnackbar(true);
        clearInterval(pollingInterval);
      }
    }
  };
  useEffect(() => {
    if (iframesrc !== null && requestId) {
      const interval = setInterval(() => {
        startPollingResult(requestId);
      }, 15000);
      setPollingInterval(interval);

      return () => clearInterval(interval);
    }
  }, [iframesrc, requestId, pollingCounter]);

  const handleClick = async () => {
    gaCustomEvent(
      String.gaEventName.acrPortfolio,
      String.gaEventClickName.acrPortfolioFetchInfoConnectAllAccounts,
      verifyData.customerId,
    );
    EnterManually(true);

    const response = await startJouenry({ userId: userId });
    if (response.httpCode === 200) {
      setIframesrc(response.response.redirectUrl);
      setRequestId(response.response.requestId);

      setOpen(true);
    }
    if (response === typeof "String") {
      setSnackbarMessage({ message: response, severity: String.ErrorSeverity });
      setShowSnackbar(true);
    }
  };
  const manualButton = () => {
    gaCustomEvent(
      String.gaEventName.acrPortfolio,
      String.gaEventClickName.acrPortfolioFetchInfoManually,
      verifyData.customerId,
    );
    EnterManually(false);
    navigation("/financialsnapshot", { state: { replace: false } });
  };
  return (
    <>
      <Box
        sx={{
          height: "100vh",
        }}
      >
        <Container sx={{ flexGrow: 1 }}>
          <PageTitle />
          <JourneyProgressStepper />
        </Container>
        <Container>
          <Typography
            sx={{
              mt: "32px",
              fontSize: "13px",
              fontFamily: fonts.notoSans,
              color: colors.NeutralDark700,
              fontWeight: 400
            }}
          >
            {String.AccountAggregator.chooseHeading}
          </Typography>

          <Box
            sx={{
              mt: "8px",
              p: "16px",
              borderRadius: "12px",
              textAlign: "center",
              backgroundColor: colors.LightSlateGray,
            }}
          >
            <Box
              sx={{
                position: "relative",
                display: "inline-block",
                maxWidth: "140px",
              }}
            >
              <Box
                component="img"
                src={ImageLibrary.FINANCIAL_SHADOW}
                alt=""
                aria-hidden="true"
                sx={{
                  position: "absolute",
                  left: "50%",
                  top: 30,
                  transform: "translateX(-50%)",
                  width: "100%",
                  height: "auto",
                  zIndex: 0,
                }}
              />
              <Box
                component="img"
                src={ImageLibrary.FINANCIAL_DETAIL}
                alt=""
                aria-hidden="true"
                sx={{
                  position: "relative",
                  zIndex: 1,
                  display: "block",
                  width: "100%",
                  height: "auto",
                }}
              />
            </Box>

            <Typography
              sx={{
                mt: "16px",
                fontSize: "16px",
                fontFamily: fonts.notoSans,
                color: colors.PrimaryWoodSmoke,
                fontWeight: 400
              }}
            >
              {String.AccountAggregator.fetchDigitallyTitle}
            </Typography>
            <Typography
              sx={{
                mt: "8px",
                fontSize: "13px",
                fontFamily: fonts.notoSans,
                color: colors.NeutralDark600,
                fontWeight: 400
              }}
            >
              {String.AccountAggregator.fetchDigitallyDescription}
            </Typography>

            <Box
              sx={{
                mt: "20px",
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "center",
              }}
            >
              {String.AccountAggregator.linkSteps.map((step, index) => (
                <React.Fragment key={step}>
                  {index > 0 && (
                    <Box
                      component="img"
                      src={ImageLibrary.ARROW_LONG}
                      alt=""
                      aria-hidden="true"
                      sx={{ width: "48px", mt: "14px", flexShrink: 0 }}
                    />
                  )}
                  <Box sx={{ width: "88px" }}>
                    <Box sx={{ position: "relative", display: "inline-flex" }}>
                      <Box
                        component="img"
                        src={ImageLibrary.WHITE_ELLIPSE}
                        alt=""
                        aria-hidden="true"
                        sx={{ display: "block", width: "32px" }}
                      />
                      <Box
                        component="span"
                        sx={{
                          position: "absolute",
                          inset: 0,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "16px",
                          fontFamily: fonts.notoSans,
                          fontWeight: 700,
                          color: colors.NeutralDark700,
                        }}
                      >
                        {index + 1}
                      </Box>
                    </Box>
                    <Typography
                      sx={{
                        mt: "6px",
                        fontSize: "10px",
                        fontFamily: fonts.notoSans,
                        fontWeight: 700,
                        color: colors.SecondaryMidnightBlue,
                      }}
                    >
                      {step}
                    </Typography>
                  </Box>
                </React.Fragment>
              ))}
            </Box>

            <Box sx={{ mt: "20px" }}>
              <Button
                buttonType="primary"
                size="default"
                width="100%"
                onClick={handleClick}

              >
                {String.AccountAggregator.linkAccountsButton}
              </Button>
            </Box>
          </Box>

          <Box sx={{ my: "20px" }}>
            <Divider
              width="100%"
              title={String.AccountAggregator.orSeparator}
              orientation="center"
              fontSize={16}
            />
          </Box>

          <Button
            buttonType="secondary"
            size="default"
            width="100%"
            onClick={manualButton}
          >
            {String.AccountAggregator.enterManuallyButton}
          </Button>
        </Container>
        <Modal
          open={open}
          onClose={() => {
            setOpen(false);
            if (pollingCounter >= 3) {
              setShowSnackbar(true);
            }
          }}
          aria-labelledby="webview-modal-title"
          aria-describedby="webview-modal-description"
        >
          <Box
            sx={{
              width: "100%",
              height: "100%",
              bgcolor: "background.paper",
              boxShadow: 24,
              borderRadius: 2,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {iframesrc !== null && (
              <WebViewComponent url={iframesrc} setOpen={setOpen} />
            )}
          </Box>
        </Modal>
      </Box>

      <AppToast
        open={showSnackbar}
        handleClose={() => setShowSnackbar(false)}
        message={snackbarMessage.message}
        severity={snackbarMessage.severity}
      />
    </>
  );
};

export default InfoFetch;
